import React from 'react';
import lightLogo from '../assets/ip-logo-lightmode.png';
import darkLogo from '../assets/ip-logo-darkmode.png';

const Logo = ({ variant = 'light', size = 'medium', className = '' }) => {
    const logoSrc = variant === 'dark' ? darkLogo : lightLogo;

    const sizeClasses = {
        small: { width: '80px', height: 'auto' },
        medium: { width: '120px', height: 'auto' },
        large: { width: '160px', height: 'auto' },
        xlarge: { width: '200px', height: 'auto' }
    };

    return (
        <img
            src={logoSrc}
            alt="Intellectual Point"
            style={sizeClasses[size]}
            className={className}
        />
    );
};

export default Logo;

